import React, { useState, useMemo, useEffect, useRef } from "react";
import { Box, Card, CardContent, Grid, Divider, Stack, Button } from "@mui/material";
import MaterialReactTableWithSearch from "../../../components/MaterialReactTable/MaterialReactTableWithSearch";
import { useData } from '../../../context/DataContext';
import LoadingComponent from "../../../components/Loading/LoadingComponent";
import { useLocation } from 'react-router-dom';

function EmployeesHistory() {
  const { loading } = useData();
  const scrollRef = useRef(null);
  const location = useLocation();
  const { employeesData } = location.state || {};

  const [selectedLevelId, setSelectedLevelId] = useState(null);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (employeesData && employeesData?.length > 0) {
      const defaultLevelId = employeesData[0]?.level_id;
      setSelectedLevelId(defaultLevelId);
      setTableData(employeesData[0]?.data || []);
    }
  }, [employeesData]);

  const handleEmpCountBtnClick = (levelId) => {
    const selectedEmployee = employeesData?.find(item => item.level_id === levelId);
    if (selectedEmployee) {
      setSelectedLevelId(levelId);
      setTableData(selectedEmployee?.data || []);
    }
  };

  const empHistoryColumn = useMemo(() => [
    {
      accessorFn: (row, index) => index + 1,
      header: 'SNO',
      id: 'id',
        enableGlobalFilter: false,
    },
    {
      accessorKey: "user_name",
      header: "Name",
      size: 150,
      accessorFn: (row) => row.user_name ?? "-",
    },
    {
      accessorKey: "mobile_no",
      header: 'Mobile',
      size: 150,
      accessorFn: (row) => row.mobile_no ?? "-",
    },
    {
      accessorKey: "gender",
      header: "Gender",
      accessorFn: (row) => row.gender ?? "-",
    },
    {
      accessorKey: "education",
      header: "Education",
      accessorFn: (row) => row.education ?? "-",
    },
    {
      accessorKey: "experience",
      header: "Experience",
      accessorFn: (row) => row.experience ?? "-",
    },
  ], []);


  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <Box>
      <Card elevation={6}>
        <CardContent>

          <Divider sx={{ my: 0,   bgcolor: '#f5f1f1ff' }} />

          {employeesData && employeesData?.length > 0 ? (
            <Box sx={{ p: 2 }}>
              <Grid container spacing={1}>
                <Box ref={scrollRef}
                  sx={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    scrollBehavior: "smooth",
                    width: "100%",
                    px: 1, mb: 2,
                    "&::-webkit-scrollbar": { display: "none" },
                  }}>
                  <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                    {employeesData.map((item, index) => (
                      <Box key={index} sx={{ display: "inline-block", textAlign: "center" }}>
                        <Button
                          key={item.value}
                          startIcon={item.icon}
                          variant={selectedLevelId === item.level_id ? "contained" : "outlined"}
                          color="success"
                          onClick={() => handleEmpCountBtnClick(item.level_id)}
                          sx={{
                            textTransform: "none", borderRadius: 2,
                            "&:hover": {
                              backgroundColor: selectedLevelId === item.level_id
                                ? "success.dark"
                                : "success.main",
                              color: "#fff",
                              borderColor: "success.main",
                            },
                          }}
                        >
                          {item.user_level_name} {item.data?.length || 0}
                        </Button>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Grid>
            </Box>
          ) : ("No employees available at the moment")}

          <Grid container spacing={1}>
            <Grid item size={{ xs: 12, md: 12 }}>
              <MaterialReactTableWithSearch
                data={tableData}
                columns={empHistoryColumn}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default EmployeesHistory;
